import { ErrorBlock } from 'components/errorBlock';

interface PotreeContainerProps {
    isError: boolean;
    errorMsg?: string;
}

export default function PotreeContainer({
    isError,
    errorMsg,
}: PotreeContainerProps) {
    return (
        <div>
            <div className="potree_container">
                {isError ? (
                    <ErrorBlock errorMessage={errorMsg as string} />
                ) : (
                    <>
                        <div id="potree_render_area">
                            <div
                                id="cesiumContainer"
                                style={{
                                    position: 'absolute',
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'grey',
                                    display: 'none',
                                }}
                            ></div>
                        </div>
                        {/* <div id="potree_sidebar_container"></div> */}
                    </>
                )}
            </div>
        </div>
    );
}
